module.exports = __webpack_public_path__ + "img/etiquetado9.8b76b505.jpg";